import { Window } from 'styles/Window';
import { useTitle } from 'hookrouter';
import { posts2021 } from 'routes';
import SearchField from 'react-search-field';

import { useState } from 'react';

//Columns defines table headings and properties to be placed into the body
const columns = [{ heading: 'Date', property: 'date' }, { heading: 'Title', property: 'title' }]

//Generate the table
//https://codereview.stackexchange.com/questions/212250/generating-a-table-based-on-an-array-of-objects
const Table = ({ columns, data, propertyAsKey }) => {
  return (
    <table className='directory'>
        <thead>
            <tr>{columns.map(col => <th key={`header-${col.heading}`}>{col.heading}</th>)}</tr>
        </thead>
        <tbody>
            {data.map(item =>
                <tr key={`${item[propertyAsKey]}-row`}>
                    {columns.map(col => <td key={`${item[propertyAsKey]}-${col.property}`}>{item[col.property]}</td>)}
                </tr>
            )}
        </tbody>
    </table>
  )
};

const filterPosts = (posts, query) => {
    // console.log(posts)
    // console.log(query);
    if (!query) {
        return posts;
    }
    return posts.filter((post) => {
        const postName = post.fullname.toLowerCase();
        return postName.includes(query.toLowerCase());
    });
};


function Posts() {
  useTitle("YTH's Posts");
  const [postlist, setPostList] = useState(posts2021)

  const updateTable = (value, event) => {
    const filtered = filterPosts(posts2021, value);
    setPostList(filtered);
    // console.log("onChange");
    // console.log(filtered);
    // console.log(postlist);
  };

  return (
    (
    <Window>
      <p className="pagetitle">Posts</p>
      {/* <p>This is the Posts Directory!</p> */}
      <SearchField
        placeholder='Search Posts by Title, Date'
        onChange={updateTable}
      />
      {/* <p className="title">2021</p> */}
      <Table columns={columns} data={postlist} propertyAsKey='date' />
    </Window>
    )
  )
};

export default Posts;
